import { Controller } from 'stimulus';
import { post } from '@rails/request.js';

export default class extends Controller {
  static values = {
    analyticsApiPath: String,
    courseTitle: String,
    videoTitle: String,
  };

  #tracked = false;

  async track() {
    if (this.#tracked) {
      return;
    }

    this.#tracked = true;

    const response = await post(this.analyticsApiPathValue, {
      body: JSON.stringify({
        event: {
          name: 'Video Lesson Watched',
          properties: {
            course_title: this.courseTitleValue,
            location: window.location.href,
            video_title: this.videoTitleValue,
          },
        },
      }),
    });

    if (!response.ok) {
      console.error('Failed to track walkthrough video:', response.statusCode);
    }
  }
}
